import Step1 from './img/steps1.webp'
import Step2 from './img/steps2.webp'
import Step3 from './img/steps3.webp'


export const stepsData = [
  {
    image: Step1,
    title1: 'Apply',
    title2: 'online',
    desc: 'Click the apply button below and follow the prompts.'
  },
  {
    image: Step2,
    title1: 'Interview with',
    title2: 'Web3m',
    desc: 'Schedule a call with the Web3m executive team.'
  },
  {
    image: Step3,
    title1: 'Purchase',
    title2: 'the NFT',
    desc: 'After approved, you’ll get a link for purchasing Web3m NFT—and become a member.'
  },
]